import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AuthHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  function clearSessionStorage() {
    sessionStorage.clear();
    localStorage.setItem('clearSessionStorage', Date.now()+"");
}

window.addEventListener('storage', (event) => {
    if (event.key === 'clearSessionStorage') {
        sessionStorage.clear();
        window.location.href = "/"
    }
});
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const loggedIn = params.get("logout");
    if ( window.location.href.includes("logout=true")) {

   document.cookie = "logedIn=false"
  // sessionStorage.removeItem("accept-data");
  // localStorage.removeItem("token");
  // localStorage.removeItem("id_token");
  // localStorage.removeItem("refresh_token");
  // localStorage.removeItem("token_expire");
  // localStorage.removeItem("CurrentApplication");
  // localStorage.removeItem("tabs");
  // clearSessionStorage()
  // window.location.href = "/"

  sessionStorage.removeItem("Logout")
    }
  }, [location]);

  return null;
};

export default AuthHandler;
